/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { InsurerDto } from '../models/insurer-dto';
import { insurerGet } from '../fn/insurer/insurer-get';
import { InsurerGet$Params } from '../fn/insurer/insurer-get';
import { insurerGetAllForDeclarationProcess } from '../fn/insurer/insurer-get-all-for-declaration-process';
import { InsurerGetAllForDeclarationProcess$Params } from '../fn/insurer/insurer-get-all-for-declaration-process';

@Injectable({ providedIn: 'root' })
export class InsurerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `insurerGet()` */
  static readonly InsurerGetPath = '/v1/Insurer/Get';

  /**
   * Search insurers,   Permissions [LIGHT_LOGIN_USER|AuthenticatedUser] ,   Restricted to [KIOSK_HOME|INSURER].
   *
   * It will return all matching elements on yours filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insurerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  insurerGet$Response(params?: InsurerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InsurerDto>>> {
    return insurerGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Search insurers,   Permissions [LIGHT_LOGIN_USER|AuthenticatedUser] ,   Restricted to [KIOSK_HOME|INSURER].
   *
   * It will return all matching elements on yours filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insurerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  insurerGet(params?: InsurerGet$Params, context?: HttpContext): Observable<Array<InsurerDto>> {
    return this.insurerGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<InsurerDto>>): Array<InsurerDto> => r.body)
    );
  }

  /** Path part for operation `insurerGetAllForDeclarationProcess()` */
  static readonly InsurerGetAllForDeclarationProcessPath = '/v1/Insurer/GetAllForDeclarationProcess';

  /**
   * Get active and visible insurers with all messages,   Permissions [LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   * It will return all matching insurers on yours filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insurerGetAllForDeclarationProcess()` instead.
   *
   * This method doesn't expect any request body.
   */
  insurerGetAllForDeclarationProcess$Response(params?: InsurerGetAllForDeclarationProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InsurerDto>>> {
    return insurerGetAllForDeclarationProcess(this.http, this.rootUrl, params, context);
  }

  /**
   * Get active and visible insurers with all messages,   Permissions [LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   * It will return all matching insurers on yours filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insurerGetAllForDeclarationProcess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  insurerGetAllForDeclarationProcess(params?: InsurerGetAllForDeclarationProcess$Params, context?: HttpContext): Observable<Array<InsurerDto>> {
    return this.insurerGetAllForDeclarationProcess$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<InsurerDto>>): Array<InsurerDto> => r.body)
    );
  }

}
